const styles = `
    .name{
        font-size: 32px;
        color: var(--white);
        font-weight: bold;
        text-transform: uppercase;
    }

    .info{
        font-size: 20px;
        color: var(--light-gray);
    }
`

export {styles}
